import gql from 'graphql-tag'

export const getBlogs = gql`
  query theme(
    $themeId: ID!,
    $systemType:String,
    $patientId: ID,
  ) {
    theme(
      themeId: $themeId,
      systemType:$systemType
      patientId: $patientId
    ) {
      _id
      endAt
      themes {
        _id
        type
        title
        content
        videoSources{
          url
          desc
          title
        }
        comments{
          _id
          content
          # userId
          user {
            _id
            nickname
            avatar
          }
          votes
          createdAt
        }
      }
    }
  }
`
export const shareActivity = gql`
  query shareActivity(
    $activityId: ID!,
    $systemType: String!,
    $patientId: String!,
  ) {
    shareActivity(
    activityId :$activityId
    systemType :$systemType
    patientId :$patientId
  ) {
      meShare
      hadShare
      videoPlayCount
  }
}
`



// WEBPACK FOOTER //
// ./src/modules/theme/actions/queries.js